/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TAnnouncementsRelevanceConfirmNotActualModel = IModel<
  IAnnouncementsRelevanceConfirmNotActualRequest,
  TAnnouncementsRelevanceConfirmNotActualResponse
>;

export interface IAnnouncementsRelevanceConfirmNotActualRequest {
  guid?: string | null;
  notificationType?: ENotificationType | null;
}

export type TAnnouncementsRelevanceConfirmNotActualResponse =
  | IAnnouncementsRelevanceConfirmNotActualResponse204
  | IAnnouncementsRelevanceConfirmNotActualResponse400;

export interface IAnnouncementsRelevanceConfirmNotActualResponse204 extends IModelResponse<{}> {
  statusCode: 204;
}

export interface IAnnouncementsRelevanceConfirmNotActualResponse400
  extends IModelResponse<IAnnouncementsRelevanceConfirmNotActualResponseError> {
  statusCode: 400;
}

export interface IAnnouncementsRelevanceConfirmNotActualResponseError {
  errors: any[];
  message: string;
}

export type TResponses = {} | IAnnouncementsRelevanceConfirmNotActualResponseError;

export enum ENotificationType {
  /** undefined **/
  Email = 'email',
  /** undefined **/
  Lk = 'lk',
  /** undefined **/
  Report = 'report',
  /** undefined **/
  Site = 'site',
  /** undefined **/
  Chat = 'chat',
  /** undefined **/
  Ivr = 'ivr',
  /** undefined **/
  Sms = 'sms',
  /** undefined **/
  Popup = 'popup',
  /** undefined **/
  Hlr = 'hlr',
  /** undefined **/
  WhatsApp = 'whatsApp',
}

export interface IMappers<TResponse204, TResponse400> {
  204(): TResponse204;
  400(response: IAnnouncementsRelevanceConfirmNotActualResponseError): TResponse400;
}
